import type { Aop, Territory } from '../types/dashboard';

const aop = (
  id: string,
  name: string,
  venue: string,
  weight: number,
  qualityAdj: number,
  zipStart: number,
  zipCount: number
): Aop => ({ id, name, venue, weight, qualityAdj, zipStart, zipCount });

export const territories: Territory[] = [
  {
    id: 'clt', name: 'Charlotte North', state: 'NC', ad: 'Rob Hale', fbc: 'Dana Whitfield', launchMonth: 0,
    size: 880, growth: 0.05, quality: 0.5, digitalShare: 0.56, priceFactor: 1.0,
    aops: [
      aop('clt-hv', 'Huntersville', 'Bradford Park Fields', 0.4, 0.02, 28031, 6),
      aop('clt-uc', 'University City', 'Mallard Creek Rec Center', 0.35, -0.02, 28213, 5),
      aop('clt-mv', 'Mooresville', 'Liberty Park', 0.25, 0, 28115, 4),
    ],
  },
  {
    id: 'ral', name: 'Raleigh–Cary', state: 'NC', ad: 'Rob Hale', fbc: 'Dana Whitfield', launchMonth: 0,
    size: 820, growth: 0.07, quality: 0.7, digitalShare: 0.6, priceFactor: 1.04,
    aops: [
      aop('ral-cy', 'Cary', 'Thomas Brooks Park', 0.45, 0.02, 27511, 6),
      aop('ral-nr', 'North Raleigh', 'Millbrook Exchange Park', 0.35, 0, 27609, 5),
      aop('ral-ax', 'Apex', 'Kelly Road Park', 0.2, 0.01, 27502, 3),
    ],
  },
  {
    id: 'atl', name: 'Atlanta Northeast', state: 'GA', ad: 'Tina Brooks', fbc: 'Marcus Ortega', launchMonth: 0,
    size: 1050, growth: -0.03, quality: -0.2, digitalShare: 0.62, priceFactor: 1.0,
    aops: [
      aop('atl-al', 'Alpharetta', 'Wills Park', 0.4, 0, 30004, 6),
      aop('atl-jc', 'Johns Creek', 'Newtown Park', 0.35, -0.03, 30022, 4),
      aop('atl-du', 'Duluth', 'Bunten Road Park', 0.25, -0.04, 30096, 4),
    ],
  },
  {
    id: 'tpa', name: 'Tampa Bay', state: 'FL', ad: 'Tina Brooks', fbc: 'Marcus Ortega', launchMonth: 0,
    size: 760, growth: 0.02, quality: 0.1, digitalShare: 0.5, priceFactor: 0.97,
    aops: [
      aop('tpa-br', 'Brandon', 'Brandon Sports Complex', 0.5, 0.01, 33510, 5),
      aop('tpa-wc', 'Westchase', 'Westchase Rec Fields', 0.5, -0.01, 33626, 4),
    ],
  },
  {
    id: 'orl', name: 'Orlando West', state: 'FL', ad: 'Tina Brooks', fbc: 'Marcus Ortega', launchMonth: 0,
    size: 690, growth: -0.06, quality: -0.5, digitalShare: 0.64, priceFactor: 0.96,
    aops: [
      aop('orl-wg', 'Winter Garden', 'Tucker Ranch Park', 0.55, -0.02, 34787, 5),
      aop('orl-wm', 'Windermere', 'Lake Butler Fields', 0.45, -0.03, 34786, 3),
    ],
  },
  {
    id: 'jax', name: 'Jacksonville', state: 'FL', ad: null, fbc: 'Marcus Ortega', launchMonth: 0,
    size: 520, growth: 0.01, quality: -0.3, digitalShare: 0.48, priceFactor: 0.94,
    aops: [
      aop('jax-md', 'Mandarin', 'Losco Regional Park', 0.5, 0, 32257, 5),
      aop('jax-bc', 'Beaches', 'Jarboe Park', 0.5, -0.02, 32250, 4),
    ],
  },
  {
    id: 'dal', name: 'Dallas North', state: 'TX', ad: 'Luis Ferreira', fbc: 'Priya Raman', launchMonth: 0,
    size: 1120, growth: 0.06, quality: 0.4, digitalShare: 0.58, priceFactor: 1.03,
    aops: [
      aop('dal-fr', 'Frisco', 'Harold Bacchus Park', 0.4, 0.02, 75033, 5),
      aop('dal-pl', 'Plano', 'Carpenter Park', 0.35, 0, 75023, 5),
      aop('dal-mk', 'McKinney', 'Gabe Nesbitt Park', 0.25, 0.01, 75070, 4),
    ],
  },
  {
    id: 'aus', name: 'Austin', state: 'TX', ad: 'Luis Ferreira', fbc: 'Priya Raman', launchMonth: 0,
    size: 840, growth: 0.09, quality: 0.6, digitalShare: 0.66, priceFactor: 1.05,
    aops: [
      aop('aus-rr', 'Round Rock', 'Old Settlers Park', 0.55, 0.02, 78664, 5),
      aop('aus-cp', 'Cedar Park', 'Milburn Park', 0.45, 0.01, 78613, 4),
    ],
  },
  {
    id: 'hou', name: 'Houston West', state: 'TX', ad: 'Luis Ferreira', fbc: 'Priya Raman', launchMonth: 0,
    size: 980, growth: -0.02, quality: -0.1, digitalShare: 0.52, priceFactor: 0.98,
    aops: [
      aop('hou-ky', 'Katy', 'Mary Jo Peckham Park', 0.45, 0, 77494, 5),
      aop('hou-cy', 'Cypress', 'Lone Star College Fields', 0.35, -0.02, 77429, 5),
      aop('hou-sl', 'Sugar Land', 'Imperial Park', 0.2, 0.01, 77479, 3),
    ],
  },
  {
    id: 'phx', name: 'Phoenix East Valley', state: 'AZ', ad: 'Angela Moss', fbc: 'Kevin Lutz', launchMonth: 0,
    size: 870, growth: 0.03, quality: 0, digitalShare: 0.6, priceFactor: 1.0,
    aops: [
      aop('phx-gb', 'Gilbert', 'Freestone Park', 0.4, 0.01, 85234, 5),
      aop('phx-ch', 'Chandler', 'Tumbleweed Park', 0.35, 0, 85225, 5),
      aop('phx-ms', 'Mesa', 'Red Mountain Park', 0.25, -0.02, 85215, 4),
    ],
  },
  {
    id: 'den', name: 'Denver South', state: 'CO', ad: 'Angela Moss', fbc: 'Kevin Lutz', launchMonth: 0,
    size: 640, growth: -0.04, quality: -0.4, digitalShare: 0.53, priceFactor: 1.06,
    aops: [
      aop('den-hr', 'Highlands Ranch', 'Redstone Park', 0.55, -0.01, 80126, 4),
      aop('den-pk', 'Parker', "O'Brien Park", 0.45, -0.03, 80134, 3),
    ],
  },
  {
    id: 'nsh', name: 'Nashville', state: 'TN', ad: 'Rob Hale', fbc: 'Dana Whitfield', launchMonth: 0,
    size: 700, growth: 0.08, quality: 0.3, digitalShare: 0.57, priceFactor: 1.01,
    aops: [
      aop('nsh-fk', 'Franklin', 'Jim Warren Park', 0.5, 0.02, 37064, 4),
      aop('nsh-hv', 'Hendersonville', 'Drakes Creek Park', 0.5, 0, 37075, 3),
    ],
  },
  {
    id: 'col', name: 'Columbus', state: 'OH', ad: null, fbc: 'Kevin Lutz', launchMonth: 0,
    size: 580, growth: -0.05, quality: -0.6, digitalShare: 0.45, priceFactor: 0.93,
    aops: [
      aop('col-db', 'Dublin', 'Darree Fields', 0.5, -0.02, 43016, 4),
      aop('col-wv', 'Westerville', 'Alum Creek Park', 0.5, -0.03, 43081, 4),
    ],
  },
  {
    id: 'ind', name: 'Indianapolis North', state: 'IN', ad: 'Angela Moss', fbc: 'Kevin Lutz', launchMonth: 0,
    size: 610, growth: 0.02, quality: 0.2, digitalShare: 0.5, priceFactor: 0.95,
    aops: [
      aop('ind-cm', 'Carmel', 'West Park', 0.5, 0.01, 46032, 4),
      aop('ind-fs', 'Fishers', 'Holland Park', 0.5, 0, 46037, 4),
    ],
  },
  {
    id: 'kc', name: 'Kansas City', state: 'KS/MO', ad: null, fbc: 'Priya Raman', launchMonth: 15,
    size: 520, growth: 0.12, quality: 0, digitalShare: 0.55, priceFactor: 0.97,
    aops: [
      aop('kc-op', 'Overland Park', 'Heritage Park', 0.6, 0, 66213, 5),
      aop('kc-ls', "Lee's Summit", 'Legacy Park', 0.4, -0.01, 64081, 3),
    ],
  },
  {
    id: 'sd', name: 'San Diego North', state: 'CA', ad: 'Luis Ferreira', fbc: 'Priya Raman', launchMonth: 26,
    size: 600, growth: 0.15, quality: 0.1, digitalShare: 0.68, priceFactor: 1.12,
    aops: [
      aop('sd-cb', 'Carlsbad', 'Poinsettia Park', 0.55, 0.01, 92009, 4),
      aop('sd-es', 'Escondido', 'Kit Carson Park', 0.45, -0.02, 92025, 4),
    ],
  },
];
